// The app's React Query configuration, in one place: the browser's single client and each server render's own.
import { QueryClient } from '@tanstack/react-query';

import { APP_DATA_KEY } from '~/lib/app-data/keys';

export function createQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
      },
    },
  });
  // App data stays cached for the whole visit: data only a closed menu reads would otherwise be dropped and suspend
  // the page when the menu opens. A login clears it, and a write updates or invalidates its own part. Each part's own
  // staleTime (see its query) decides when it reloads, which happens when a component next mounts it, not on every
  // return to the tab.
  queryClient.setQueryDefaults(APP_DATA_KEY, { gcTime: Infinity, refetchOnWindowFocus: false });
  return queryClient;
}
